module.exports = __webpack_public_path__ + "static/media/TronlinkPro.c96d6fcf.jpg";